import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import EditTraderLayer from "../components/EditTraderLayer";


const EditTraderPage = () => {
  return (
    <>



        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Edit Trader  </h5><Breadcrumb title="Edit Trader" /></div>

        {/* UsersListLayer */}
        <EditTraderLayer />


    </>
  );
};

export default EditTraderPage; 